module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nyx-5cd688849ec10a5e0a453786575ac316.png";